import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledPasswordFormInputsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexDirection: "column",
}));

export const StyledResetPasswordBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(3),
  },
}));
